import '.z{width:100%;}.ssr-plugin'
import '.c9{max-width:100%;}.ssr-plugin'
import '.ca{margin-left:0px;}.ssr-plugin'
import '.cb{margin-right:0px;}.ssr-plugin'
import '.ba{margin-bottom:2rem;}.ssr-plugin'
import '.cc{height:auto;}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.cd{overflow-wrap:break-word;}.ssr-plugin'
import '.ce{word-break:break-word;}.ssr-plugin'
import sanitizeHtml from 'sanitize-html'
import parse, { DOMNode, domToReact, Element } from 'html-react-parser'
import React from 'react'
import { Title } from '../typography/Title'
import { Paragraph } from '../typography/Paragraph'
import { UnorderedList } from '../typography/UnorderedList'
import { Quote } from '../typography/Quote'
import { styled } from 'inlines'
import { Image } from '../image/Image'

type ComponentMap = {
  [tagName: string]: React.ComponentType<any>
}

interface SafeHtmlProps {
  html: string
  components?: ComponentMap
}

const Figure = ({ children }: { children: React.ReactNode }) => {
  return (
    <styled.figure className="z c9 ca cb ba cc p"
      style={{
        '& > img': {
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '1.25rem',
          display: 'block',
        },
      }}
    >
      {children}
    </styled.figure>
  )
}

const defaultComponents: ComponentMap = {
  h1: ({ children }) => <Title.H1>{children}</Title.H1>,
  h2: ({ children }) => <Title.H2>{children}</Title.H2>,
  h3: ({ children }) => <Title.H3>{children}</Title.H3>,
  h4: ({ children }) => <Title.H4>{children}</Title.H4>,
  h5: ({ children }) => <Title.H5>{children}</Title.H5>,
  p: ({ children }) => <Paragraph.Medium>{children}</Paragraph.Medium>,
  //   a: ({ href, children }) => (
  //     <a
  //       href={href}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       className="text-blue-600 underline"
  //     >
  //       {children}
  //     </a>
  //   ),
  ul: ({ children }) => <UnorderedList>{children}</UnorderedList>,
  blockquote: ({ children }) => <Quote>{children}</Quote>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  figure: ({ children }) => <Figure>{children}</Figure>,
  img: ({ src, alt }) => (
    <Image
      src={src}
      alt={alt}
      style={{
        maxWidth: '100%',
        width: 'auto',
        height: 'auto',
        display: 'block',
      }}
    />
  ),
}

export function SafeHtml({ html, components = {} }: SafeHtmlProps) {
  const mergedComponents = {
    ...defaultComponents,
    ...components,
  }

  const cleanHtml = sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'img',
      'figure',
    ]),
    allowedAttributes: {
      '*': ['class'],
      a: ['href', 'target', 'rel'],
      img: ['src', 'alt'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
  })

  return (
    <div className="z c9 cd ce"
    >
      {parse(cleanHtml, {
        replace: (node) => {
          if (node instanceof Element) {
            const Component = mergedComponents[node.name]
            if (Component) {
              return (
                <Component {...node.attribs}>
                  {domToReact(node.children as DOMNode[])}
                </Component>
              )
            }
          }
        },
      })}
    </div>
  )
}
